"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  margin: ", ";\n\n  &::after {\n    content: '';\n    height: 32px;\n    right: 0;\n    position: absolute;\n    z-index: 3;\n    top: -16px;\n    width: 1px;\n    background: rgba(255, 255, 255, 0.2);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var DividerSpan = _styledComponents["default"].span(_templateObject(), function (props) {
  return props.theme.spacing(0, 6);
});

var _default = function _default() {
  return /*#__PURE__*/_react["default"].createElement(DividerSpan, null);
};

exports["default"] = _default;